module.exports = __webpack_public_path__ + "static/media/img_playground_post_default.1a659b8b.svg";